// Import everything from autoload


// import local dependencies
import common from './routes/common';

/**	
 * Ready equivalent
 */
(function(funcName, baseObj) {
    // The public function name defaults to window.docReady
    // but you can pass in your own object and own function name and those will be used
    // if you want to put them in a different namespace
    funcName = funcName || 'docReady';
    baseObj = baseObj || window;
    var readyList = [];
    var readyFired = false;
    var readyEventHandlersInstalled = false;

    // call this when the document is ready
    // this function protects itself against being called more than once
    function ready() {
        if (!readyFired) {
            // this must be set to true before we start calling callbacks
            readyFired = true;
            for (var i = 0; i < readyList.length; i++) {
                // if a callback here happens to add new ready handlers,
                // the docReady() function will see that it already fired
                // and will schedule the callback to run right after
                // this event loop finishes so all handlers will still execute
                // in order and no new ones will be added to the readyList
                // while we are processing the list
                readyList[i].fn.call(window, readyList[i].ctx);
            }
            // allow any closures held by these functions to free
            readyList = [];
        }
    }

    function readyStateChange() {
        if ( document.readyState === 'complete' ) {
            ready();
        }
    }

    // This is the one public interface
    // docReady(fn, context);
    // the context argument is optional - if present, it will be passed
    // as an argument to the callback
    baseObj[funcName] = function(callback, context) {
        if (typeof callback !== 'function') {
            throw new TypeError('callback for docReady(fn) must be a function');
        }
        // if ready has already fired, then just schedule the callback
        // to fire asynchronously, but right away
        if (readyFired) {
            setTimeout(function() {callback(context);}, 1);
            return;
        } else {
            // add the function and context to the list
            readyList.push({fn: callback, ctx: context});
        }
        // if document already ready to go, schedule the ready function to run
        if (document.readyState === 'complete') {
            setTimeout(ready, 1);
        } else if (!readyEventHandlersInstalled) {
            // otherwise if we don't have event handlers installed, install them
            if (document.addEventListener) {
                // first choice is DOMContentLoaded event
                document.addEventListener('DOMContentLoaded', ready, false);
                // backup is window load event
                window.addEventListener('load', ready, false);
            } else {
                // must be IE
                document.attachEvent('onreadystatechange', readyStateChange);
                window.attachEvent('onload', ready);
            }
            readyEventHandlersInstalled = true;
        }
    }
})('docReady', window);

window.docReady(function () {
	common.init();
    function clearMegaPanel() {
        var link = $('.mega-menu-link');
        var tab = $('.mega-tab');
        var body = $('body');
        link.removeClass('active');
        tab.fadeOut(200);
        body.removeClass('menu-open');
    }

    function clearAsideMenu() {
        var item = $('.top-item');
        var tab = $('.aside-links');
        item.removeClass('open-links');
        tab.fadeOut(200);
    }

    $('.mega-menu-link').click(function(e){
        e.preventDefault();
        if ($(this).hasClass('active')) {
            clearMegaPanel();
        } else {
            clearMegaPanel();
            $(this).addClass('active').next('.mega-tab').fadeIn(200);
            $('body').addClass('menu-open');
        }
    });

    $('.next-level').click(function(e){
        e.preventDefault();
        $(this).next('.mob-nav-tab').addClass('active');
    });

    $('.go-back').click(function(){
        $('.mob-nav-tab').removeClass('active');
    });

    $('.mob-nav-opener').click(function(){
        $('.mob-nav-opener').toggleClass('opened');
        $('.mobile-nav').toggleClass('open').fadeToggle();
        $('body').toggleClass('mob-nav-opened');
    });

    $('.more .expand-menu').click(function(){
        $(this).parent().next('.level-3').slideToggle();
        $(this).parent().toggleClass('opened');
    });

    $('.top-item .wrap').click(function(){
        if ($(this).parent().hasClass('open-links')) {
            clearAsideMenu();
        } else {
            clearAsideMenu();
            $(this).parent().addClass('open-links').find('.aside-links').fadeIn(200);
        }
    });

    $(document).mouseup(e => {
        if (!$('.mega-tab').is(e.target) 
        && $('.mega-tab').has(e.target).length === 0
        && !$('.mega-menu-link').is(e.target)) {
            clearMegaPanel();
        }
        if (!$('.aside-links').is(e.target) 
        && $('.aside-links').has(e.target).length === 0
        && !$('.open-links .wrap').is(e.target)) {
            clearAsideMenu();
        }
    });

    $('.scroll-btn').click(function(e){
        e.preventDefault();
        var href = jQuery(this).attr('href');
        var headerHeight = $('.banner').outerHeight();
        $('html, body').animate({
            scrollTop: jQuery(href).offset().top - headerHeight,
        }, '500');
    });

    let currentIndex = 0;
    let wordWrap   = document.getElementsByClassName('spinner-words');
    if (wordWrap.length) {
        let words      = wordWrap[0].childNodes;
        let parent     = wordWrap[0].parentNode;
        let wordsCount = wordWrap[0].children.length;
        let wordWidths = [];

        setInterval(() => {
            words.forEach((element,key,words) => {
                //Last element
                if (!Object.is(words.length - 1, key)) {
                    element.classList.remove('slide-up');
                }
                wordWidths.push(element.offsetWidth);
            });

            //Auto adjust
            // if(!parent.parentNode.classList.contains('spinner-max')){
            //     parent.parentNode.style.setProperty('width', 'calc(50% + ' + Math.max.apply(Math, wordWidths)+ 'px');
            // }
            
            if(words[currentIndex]) {
                words[currentIndex].classList.add('animated', 'slide-up');
            }

            currentIndex++;

            if(currentIndex == wordsCount){
                parent.classList.add('active');
            }

        }, 1700)
    }

    
    const button = document.querySelector(
        '.posts-listing .btn.ajax-load-more, .posts-filter-listing .btn.ajax-load-more, .faq-filter-listing .btn.ajax-load-more'
    );

    if (typeof button != 'undefined' && button != null) {

        if (
            document.querySelector('.posts').dataset.page ==
            document.querySelector('.posts').dataset.max
        ) {
            button.parentNode.removeChild(button);
          }

        button.addEventListener('click', (e) => {
            e.preventDefault();
            
            const news_list = document.querySelector('.posts');
            let current_page = news_list.dataset.page;
            let max_pages = news_list.dataset.max;
            let post_type = news_list.dataset.type;
            
            let params = new URLSearchParams();
            params.append('action', 'maritech_load_more_posts');
            params.append('current_page', current_page);
            params.append('max_pages', max_pages);
            params.append('post_type', post_type);

            if (typeof news_list.dataset.num != 'undefined' && news_list.dataset.num != null){
                let num = news_list.dataset.num;
                params.append('num', num);
            }

            if (typeof news_list.dataset.exclude != 'undefined' && news_list.dataset.exclude != null){
                let exclude = news_list.dataset.exclude;
                params.append('exclude', exclude);
            }
    
            // eslint-disable-next-line no-undef
            axios.post('/wp-admin/admin-ajax.php', params).then((res) => {
                news_list.innerHTML += res.data.data;   
                news_list.dataset.page++;
                if (
                    news_list.dataset.page ==
                    news_list.dataset.max
                ) {
                button.parentNode.removeChild(button);
                }
            });
        });
    }
});



// WEBPACK FOOTER //
// ./scripts/main.js